<template>
  <gs-named-modal class="gs-aff-modal" :name="name" :title="$t('frontend_sure')" width="520px" max-width="520px">
    <p>{{ messageContent }}</p>
    <div slot="footer" class="gs-aff-footer">
      <gs-button variant="outline" @click="$root.$emit('modal-close', name)">{{ $t('frontend_cancel') }}</gs-button>
      <gs-button variant="danger" @click="confirm">{{ buttonText }}</gs-button>
    </div>
  </gs-named-modal>
</template>
<script>
import '../affiliate-workspace.css';
export default {
  props: {
    name: { type: String, required: true },
    messageContent: { type: String, required: true },
    buttonText: { type: String, required: true },
  },
  methods: {
    confirm() {
      this.$root.$emit('modal-close', this.name);
      this.$emit('confirm');
    },
  },
};
</script>
